import { styled, Tooltip, tooltipClasses, TooltipProps } from '@mui/material'

const BootstrapTooltip = styled(({ className, ...props }: TooltipProps) => (
  <Tooltip
    {...props}
    arrow
    enterTouchDelay={0}
    classes={{ popper: className }}
  />
))(({ theme }) => ({
  [`& .${tooltipClasses.arrow}`]: {
    color: '#DCC1FF',
  },
  [`& .${tooltipClasses.tooltip}`]: {
    backgroundColor: '#DCC1FF',
    color: '#010101A3',
    fontSize: '14px',
    lineHeight: '20px',
    maxWidth: '400px',
    padding: '12px 16px',
    fontFamily: 'DM Mono Regular',
    borderRadius: '12px',
    [theme.breakpoints.down('xs')]: {
      fontSize: '12px',
      lineHeight: '18px',
    },
  },
}))

export default BootstrapTooltip
